import { useEffect, useState } from 'react'
import { GeometryApi, MpxSearchResultParcel } from '@cibo/core'
import { randomTillableParcel } from '@cibo/landmanager'
import { Box, Button, Stack } from '@mui/material'
import { Field, useFormikContext } from 'formik'

export const GeometryPicker = () => {
  const [parcel, setParcel] = useState<MpxSearchResultParcel>()

  const { setFieldValue } = useFormikContext()

  useEffect(() => {
    getNewParcel()
  }, [])

  const getNewParcel = () =>
    randomTillableParcel().then(parcel => {
      setParcel(parcel)

      if (parcel?.properties.tillableGeometrySlug)
        GeometryApi.getGeometry(parcel?.properties.tillableGeometrySlug).then(geometry =>
          setFieldValue('geometry', {
            detail: {
              traitId: 'geometry',
              input: { feature: { geometry } },
            },
          })
        )
    })

  return (
    <Field name="geometry">
      {() => {
        return (
          <Stack direction="row" spacing={2}>
            <Box>geometry:</Box>
            <Button variant="contained" onClick={() => getNewParcel()}>
              get random
            </Button>
            <Box>
              {parcel?.properties?.acreage}ac {parcel?.properties?.label?.primary}{' '}
              {parcel?.properties?.label?.secondary}
            </Box>
          </Stack>
        )
      }}
    </Field>
  )
}
